module.exports = __webpack_public_path__ + "static/media/darkSavedArrow.f7f1b468.svg";